var svgCache = {};
export default svgCache;


//////////////////
// WEBPACK FOOTER
// ./~/@tanem/svg-injector/esm/svg-cache.js
// module id = 248
// module chunks = 0